import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAppointmentInsurerAction} from "../../../redux/actions/PayoutAction";
import {
  AdditionalFinanceApptHeader,
  financeHeaderValue,
} from "./AdditionalFinanceApptHeader";
import { FinanceQcBulkUpload } from "./FinanceQcBulkUpload";
import Modal from "react-modal";
import { getNetworkMenuId, getToken } from "../../../Utils/types";
import { FinanceAppointmentDetails } from "./FinanceAppointmentDetails";
import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import { isLoadingAction } from "../../../Utils/helper";
import { RevertMode } from "./RevertMode";


export const InsurerBillingAppointment = ({
  rowData,
  searchFilter,
  payableData,
  setPayabelData,
  header,
  showData,
  setShowData,
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const [bulkUploadOpen,setBulkUploadOpen] = useState(false)
  const [tableIndex, setTableIndex] = useState(null);
  const [isEdit,setIsEdit] = useState({data:null,open:false})
  const [isRevert,setIsRevert] = useState({data:null,open:false})
 
  useEffect(() => {
    dispatch(
        GetAppointmentInsurerAction({
        ...searchFilter,
        sessionId: rowData?.sessionId,
        ticketId: rowData?.requestID,
        providerId: null,
        clientId:rowData?.clientId
      })
    );
  }, []);
  const downloadFile = (ele) => {
    // console.log(first)
    const apid = payableData?.map((ele)=>{
        return {appointmentId:ele?.appointmentId}
    })
    let clId = payableData.map((ele) => {
      return { clientId: ele?.clientid };
    });
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/NetworkVerification/ExportToExcelInsurerQCApprovalDetailsNetwork`;
      const  data = {
          ...searchFilter,
          isExportToExcel : true,
          appointmentIds:apid,
          clientIds:clId
          // providerIds: "",
        };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => 
        response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "InsurerQCApprovalDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
       
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
      });
  };

  return (
    <>
      <div className=" d-flex justify-content-end p-2 gap-2">
      {getNetworkMenuId()?.canEdit === true && 
      <>
      <button
          className="setting_config ascDescBtn p-2 pe-3"
          data-bs-toggle="modal"
          type="button"
          onClick={()=>setBulkUploadOpen(true)}
        >
          &nbsp;
          Bulk Revert
        </button>
       <button
          className="setting_config ascDescBtn p-2 pe-3"
          data-bs-toggle="modal"
          type="button"
          onClick={()=>downloadFile()}
        >
          &nbsp;
          Export To Excel
        </button></>}
        <button
          className="setting_config ascDescBtn p-2"
          data-bs-toggle="modal"
          data-bs-target="#additionalFilterApptHeader"
          type="button"
        >
          &nbsp;
          <i class="fa-solid fa-gear"></i>
        </button>
      </div>
      <div className="table-responsive __custom__properties pt-2">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  readOnly
                  checked={
                    payoutReducer?.getQcApprovalAppt?.length ===
                    payableData?.length
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setPayabelData(payoutReducer?.getQcApprovalAppt);
                    } else {
                      setPayabelData([]);
                    }
                  }}
                />
              </th>
              <th >Insurer Name</th>
              <th style={{textAlign:"center"}}>Case No</th>
              <th style={{textAlign:"center"}}>GST</th>
              <th style={{textAlign:"center"}}>Service Charge</th>
              <th style={{textAlign:"center"}}>Gross Amount</th>
              {header?.map((ele) => (
                <th
                  className={`${
                    ele === "Additional Test" || ele === "Tests"
                      ? "financeAdditionalTest"
                      : "addHeader"
                  }`}
                >
                  {ele}
                </th>
              ))}
              <th style={{textAlign:"center"}}>Status</th>
              <th style={{textAlign:"center"}}>Revert</th>
              {/* <th>Action</th> */}

            </tr>
          </thead>
          <tbody>
            {payoutReducer?.getQcApprovalAppt?.map((ele, itemIndex) => {
              return (
                <>
                  <tr key={ele?.clientId}>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={payableData?.some((item) => item === ele)}
                        // disabled={
                        //   ele?.requestStatus !== "Pending At Finance" &&
                        //   ele?.requestStatus !== "Partial QC" &&
                        //   ele?.requestStatus !== "Partial Finance"
                        // }
                        // checked = {}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setPayabelData([...payableData, ele]);
                          } else {
                            let arr = payableData.filter(
                              (item) => item !== ele
                            );
                            setPayabelData(arr);
                          }
                        }}
                        readOnly
                      />
                    </td>
                    <td style={{ minWidth: "220px" }}>{ele?.clientName}</td>
                    <td style={{minWidth: "100px",textAlign:"center"}}>{ele?.caseNo}</td>
                    <td style={{ minWidth: "100px",textAlign:"center"  }}>{ele?.gst?.toLocaleString('en-IN')}</td>
                    <td style={{ minWidth: "120px",textAlign:"center" }}>{ele?.serviceCharge?.toLocaleString('en-IN')}</td>
                    <td style={{ minWidth: "100px", textAlign: "center" }}>
                      {ele?.netAmount?.toLocaleString('en-IN')}
                    </td>
                    {header?.map((data) => {
                      return (
                        <td
                          style={{textAlign:data === "Test Details"?"center":""}}
                          className={`${
                            data === "Test Details"
                              ? "financeAdditionalTest"
                              : "addHeader"
                          }`}
                        >
                          {data === "Test Details" ? (
                           <>
                           {showData === true && tableIndex === itemIndex
                             ? ele[financeHeaderValue[data]]
                             : ele[financeHeaderValue[data]]
                                 .split(" ")
                                 ?.slice(0, 10)
                                 ?.join(" ")}
                               <a
                                 id="payOutShowMoreBtn"
                                 onClick={() => {
                                   if (data === "Test Details") {
                                     // setShowData(!showData);
                                     setTableIndex(itemIndex);
                                     setShowData(
                                       showData && tableIndex === itemIndex ? false : true
                                     );
                                   }
                                 }}
                               >
                                 {ele[financeHeaderValue[data]].split(" ").length <
                                 20
                                   ? ""
                                   : showData === true && tableIndex === itemIndex
                                   ? " view less"
                                   : "...view more"}
                               </a>
                         </>
                          ) : data === "Insurer Amount" || data === "HV Amount" || data === "Adjustment Amount"? ele[financeHeaderValue[data]]?.toLocaleString('en-IN') :(
                            ele[financeHeaderValue[data]]
                          )}
                        </td>
                      );
                    })}
                    <td  >
                      <p
                      style={{margin:"auto"}}
                        className={`status-style ${
                          ele?.requestStatus === "Paid"
                            ? "approved"
                            : ele?.requestStatus === "Reject By Finance" ||
                              ele?.requestStatus === "Not Paid "
                            ? "rejected"
                            : ele?.requestStatus === "Pending At Finance" ||
                              ele?.requestStatus === "Pending at Network"
                            ? "pendingAtFinance"
                            : ele?.requestStatus === "Pending For Payment"
                            ? "pendingForpayment"
                            : ele?.requestStatus === "Partial Paid"
                            ? "partialPaid"
                            : "pending"
                        }`}
                      >
                        {ele?.requestStatus}
                      </p>
                    </td>
                    <td  style={{textAlign:"center",minWidth:"150px"}}>
                    <button
                    className="btn search__btn action_export"
                    type="button"
                    onClick={() => {
                      setIsRevert({data:ele,open:true})
                    }}
                  >
                    Revert &nbsp;
                    <i class="fa-solid fa-caret-right"></i>
                  </button>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
        <div
          class="modal fade"
          id="additinalFinanceAppHeader"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <AdditionalFinanceApptHeader />
        </div>
        <Modal
            isOpen={isRevert?.open}
            className="modal-add-user-popup modal-upload-excel-popup modal-remove-billing-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <RevertMode
              searchFilter={searchFilter}
              setIsRevert={setIsRevert}
              isRevert={isRevert}
              rowData={rowData}
            />
          </Modal>
          <Modal
            isOpen={bulkUploadOpen}
            className="modal-add-user-popup modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <FinanceQcBulkUpload
              bulkUploadOpen={bulkUploadOpen}
              type={"InsurerBillingQC"}
              // searchFilter={searchFilter}
              // apiParams={apiParams}
              setBulkUploadOpen={setBulkUploadOpen}
            />
          </Modal>
          <Modal
            isOpen={isEdit.open}
            className="modal-add-user-popup modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <FinanceAppointmentDetails
              setIsEdit={setIsEdit}
              isEdit={isEdit}
              searchFilter={searchFilter}
              setPayabelData={setPayabelData}
              // apiParams={apiParams}
              // setBulkUploadOpen={setBulkUploadOpen}
            />
          </Modal>
      </div>
    </>
  );
};
